import React from 'react'
import PropTypes from 'prop-types'
import { APPLICATION_PATHS, GLOBAL_PATHS } from 'constants/paths'
import { Button } from 'reactstrap'

const GOOGLE_MAPS_URI = 'https://maps.googleapis.com/maps/api/js'
const { REACT_APP_GOOGLE_MAPS_API_KEY } = process.env

class MapDiv extends React.Component {
  render () {
    const { roundBorder } = this.props
    const isMobile = typeof window !== 'undefined' && window.innerWidth < 768
    const minHeight = this.props.minHeight ?? 500
    const borderRadius = !roundBorder ? '0px' : isMobile ? '10px' : '20px'

    return (
      <div
        id="map"
        style={{ minHeight: `${minHeight}px`, borderRadius, height: '100%' }}
      />
    )
  }

  shouldComponentUpdate () {
    return false
  }
}

class GoogleMapsOverlay extends React.Component {
  state = {
    mapsLoading: true,
    showHours: false,
    showOverlay: false,
    activeStore: null,
    isMobile: typeof window !== 'undefined' ? window.innerWidth < 768 : false,
  }

  map = null
  markers = []

  handleResize = () => {
    const isMobile = window.innerWidth < 768
    if (isMobile !== this.state.isMobile) {
      this.setState({ isMobile })

      const google = typeof window !== 'undefined' ? window.google : null
      if (this.map && google && google.maps) {
        google.maps.event.trigger(this.map, 'resize')
      }
    }
  }

  componentDidMount () {
    window.addEventListener('resize', this.handleResize)
    if (
      typeof window !== 'undefined' &&
      (!window.google || !window.google.maps)
    ) {
      this.mapsScript = document.createElement('script')
      this.mapsScript.setAttribute(
        'src',
        `${GOOGLE_MAPS_URI}?key=${REACT_APP_GOOGLE_MAPS_API_KEY}`
      )
      this.mapsScript.onload = () => {
        this.setState({ mapsLoading: false })
      }
      document.head.appendChild(this.mapsScript)
    } else {
      this.setState({ mapsLoading: false })
    }
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.handleResize)
    if (this.mapsScript) {
      this.mapsScript.onload = () => { }
    }
  }

  shouldComponentUpdate (nextProps, nextState) {
    const { selectedStore } = this.props
    const {
      mapsLoading,
      showHours,
      showOverlay,
      activeStore,
      isMobile,
    } = this.state

    if (!nextState.mapsLoading && mapsLoading) {
      return true
    }

    if (
      nextProps.selectedStore &&
      nextProps.selectedStore.storeNumber !==
      (selectedStore ? selectedStore.storeNumber : '')
    ) {
      return true
    }

    if (showHours !== nextState.showHours) {
      return true
    }

    if (showOverlay !== nextState.showOverlay) {
      return true
    }

    if (activeStore !== nextState.activeStore) {
      return true
    }

    if (isMobile !== nextState.isMobile) return true

    return false
  }

  componentDidUpdate (prevProps, prevState) {
    const { selectedStore, storeSearchResults } = this.props
    const { mapsLoading } = this.state
    const google = typeof window !== 'undefined' ? window.google : null
    if (mapsLoading || !google) return

    let center = { lat: 38, lng: -97 },
      zoom = 4
    if (selectedStore) {
      center = { lat: selectedStore.latitude, lng: selectedStore.longitude }
      zoom = 16
    } else if (storeSearchResults && storeSearchResults.length) {
      const sum = storeSearchResults
        .map(({ longitude: lng, latitude: lat }) => ({ lat, lng }))
        .reduce((a, c) => ({ lat: a.lat + c.lat, lng: a.lng + c.lng }), {
          lat: 0,
          lng: 0,
        })
      center = {
        lat: sum.lat / storeSearchResults.length,
        lng: sum.lng / storeSearchResults.length,
      }
      zoom = 10
    }

    if (!this.map) {
      this.map = new google.maps.Map(document.getElementById('map'), {
        center,
        zoom,
      })
      this.map.addListener('click', () =>
        this.setState({
          showOverlay: false,
          activeStore: null,
          showHours: false,
        })
      )
    } else {
      this.map.setCenter(center)
      this.map.setZoom(zoom)
    }

    if (
      storeSearchResults !== prevProps.storeSearchResults ||
      (prevState.mapsLoading && !mapsLoading)
    ) {
      let stores = storeSearchResults

      if ((!stores || !stores.length) && selectedStore) stores = [selectedStore]
      this.markers.forEach(m => m.setMap(null))
      this.markers = []
        ; (stores || []).forEach(store => {
          const marker = new google.maps.Marker({
            position: { lat: store.latitude, lng: store.longitude },
            map: this.map,
            title: store.addressLine1,
          })

          marker.addListener('click', () =>
            this.setState({
              showOverlay: true,
              activeStore: store,
              showHours: false,
            })
          )

          this.markers.push(marker)
        })
    }
  }


  handleFinishApplication = async () => {
    const { id } = this.props.application
    await this.props.saveLoanApplicationProgress({
      variables: {
        id,
        applicationUrl: APPLICATION_PATHS.PERSONAL,
      },
    })
    this.props.routeProps.history.push(GLOBAL_PATHS.APPLICATION)
  }

  renderHours (hours, dayOfWeek) {
    if (!hours || !hours.length) return null
    const days = [
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
      'Sunday',
    ]
    return (
      <div className="bg-secondary">
        {hours.map((day, i) => {
          const open =
            day.openTime && day.closeTime
              ? `${day.openTime} - ${day.closeTime}`
              : 'Closed'
          const isToday = days[i] === dayOfWeek
          return (
            <div
              className={`cgo-hours${isToday ? ' cgo-today' : ''}`}
              key={days[i]}
            >
              <span
                className="cgo-day"
                style={isToday ? { fontWeight: 'bold' } : {}}
              >
                {days[i]}:
              </span>
              <span
                className="cgo-time"
                style={isToday ? { fontWeight: 'bold' } : {}}
              >
                {open}
              </span>
            </div>
          )
        })}
      </div>
    )
  }

  renderOverlayCard () {
    const selectedStore = this.state.activeStore || this.props.selectedStore
    if (!selectedStore) return null

    const days = [
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
      'Sunday',
    ]
    const todayIdx = new Date().getDay() === 0 ? 6 : new Date().getDay() - 1
    const todayHours = selectedStore.hours && selectedStore.hours[todayIdx]
    const openToday =
      todayHours && todayHours.openTime && todayHours.closeTime
        ? `Open Today ${todayHours.openTime} - ${todayHours.closeTime}`
        : 'Closed'
    const formatPhone = phone => {
      if (!phone) return ''
      const cleaned = ('' + phone).replace(/\D/g, '')
      const match = cleaned.match(/^1?(\d{3})(\d{3})(\d{4})$/)
      if (match) {
        return `(${match[1]}) ${match[2]}-${match[3]}`
      }
    }
    const formattedPhone = formatPhone(selectedStore.phone)
    const { roundBorder } = this.props
    const borderType = roundBorder ? 'cgo-card-round-border bg-secondary' : 'cgo-card bg-secondary'

    return (
      <div
        className="cgo-overlay"
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          zIndex: 1000,
          maxWidth: 420,
          pointerEvents: 'auto',
        }}
      >
        <div className={borderType}>
          <div className="bg-secondar"></div>
          <div className="cgo-content">
            <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 6 }}>
              Your Nearest Store
            </div>
            <div className="cgo-title">
              <strong>Check `n Go {selectedStore.city}</strong>
            </div>
            <div className="cgo-address">
              <div>{selectedStore.addressLine1 ?? ''}</div>
              {selectedStore.addressLine2 && (
                <div>{selectedStore.addressLine2}</div>)}
              <div>
                {selectedStore.city ?? ''}, {selectedStore.state ?? ''}{' '}
                {selectedStore.postalCode ?? ''}
              </div>
              <div>
                <a
                  href={`tel:${selectedStore.phone}`}
                  style={{ color: '#e9fff3', textDecoration: 'underline' }}
                >
                  {formattedPhone}
                </a>
              </div>
              <div>
                {openToday}
                <span
                  className="toggle-link"
                  style={{
                    color: 'white',
                    cursor: 'pointer',
                    textDecoration: 'underline',
                    marginLeft: 9,
                  }}
                  onClick={() =>
                    this.setState(prev => ({ showHours: !prev.showHours }))
                  }
                >
                  {this.state.showHours ? 'Hide Hours' : 'View Hours'}
                </span>
              </div>
              {this.state.showHours &&
                this.renderHours(selectedStore.hours, days[todayIdx])}
              {this.state.isMobile && (
                <Button
                  color="primary"
                  className="w-100 border rounded-btn rounded-xl"
                  onClick={() => this.handleFinishApplication()}
                >
                  Finish Application
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }

  render () {
    const { mapsLoading, showOverlay } = this.state
    const { ignoreOverlay } = this.props

    if (mapsLoading) {
      return <div>Loading map</div>
    }

    if (ignoreOverlay) {
      return (
        <div style={{ position: 'relative', height: '100%' }}>
          <MapDiv {...this.props} />
        </div>
      )
    } else {
      return (
        <div style={{ position: 'relative', height: '100%' }}>
          <MapDiv {...this.props} />
          {showOverlay && this.renderOverlayCard()}
        </div>
      )
    }
  }

  static propTypes = {
    selectedStore: PropTypes.shape({
      storeNumber: PropTypes.number.isRequired,
      longitude: PropTypes.number.isRequired,
      latitude: PropTypes.number.isRequired,
      phone: PropTypes.string.isRequired,
      hours: PropTypes.arrayOf(
        PropTypes.shape({
          openTime: PropTypes.string,
          closeTime: PropTypes.string,
        })
      ),
      addressLine1: PropTypes.string,
      addressLine2: PropTypes.string,
      city: PropTypes.string,
      state: PropTypes.string,
      postalCode: PropTypes.string,
    }),
    storeSearchResults: PropTypes.array,
    showDetails: PropTypes.bool,
    showPartner: PropTypes.bool,
    routeProps: PropTypes.object.isRequired,
    saveLoanApplicationProgress: PropTypes.func.isRequired,
    application: PropTypes.object.isRequired,
    roundBorder: PropTypes.bool,
    ignoreOverlay: PropTypes.bool,
  }
}

export default GoogleMapsOverlay
